  //Accordion code is moved here - NC
  Array.prototype.slice.call(document.querySelectorAll('.Accordion')).forEach(function (accordion) {
  
    // Create the array of toggle elements for the accordion group
    var triggers = Array.prototype.slice.call(accordion.querySelectorAll('.Accordion-trigger'));
    var panels = Array.prototype.slice.call(accordion.querySelectorAll('.Accordion-panel'));    
    
    
    triggers.forEach(item => {
      	var item_smfr = true;
      
        item.addEventListener('click', function (event) {
            var target = event.target;

          if ( item_smfr == true) { 
            if (item.classList.contains('unit_title_row')) {
                // Check if the current toggle is expanded.
                var isExpanded = item.getAttribute('aria-expanded') == 'true';
                var active = accordion.querySelector('[aria-expanded="true"]');
              	var section = document.getElementById(item.getAttribute('aria-controls'));
              
                if (!isExpanded) {
                  // Set the expanded state on the triggering element
                  item.setAttribute('aria-expanded', 'true');
                  // Hide the accordion sections, using aria-controls to specify the desired section
                  section.removeAttribute('hidden');
                  slideDown(section, 500);
                }              
                else if (isExpanded) { 
                  item.setAttribute('aria-expanded', 'false');
                  
                  //find all triggers inside and set them to closed
                  var lesson_triggers = Array.prototype.slice.call(section.querySelectorAll('.Accordion-trigger'));
                  
                  lesson_triggers.forEach( lesson_item => {
                    	var lesson_section = document.getElementById(lesson_item.getAttribute('aria-controls'));
	                    if (lesson_section !== null) {
                        	lesson_section.setAttribute('hidden','');
                        }
                  		lesson_item.setAttribute('aria-expanded', 'false');
                  });
                  
                  // Hide the accordion sections, using aria-controls to specify the desired section
                  section.setAttribute('hidden', '');
                  slideUp(section, 500);
                }

            } else if (item.classList.contains('lesson_title_row')) {
                var isExpanded = item.getAttribute('aria-expanded') == 'true';
                var active = accordion.querySelector('[aria-expanded="true"]');
              	var hasPreview = item.getAttribute('data-has_preview') == 'true';
              
              	if (!hasPreview) return false;

              	var section = document.getElementById(item.getAttribute('aria-controls'));
              	var iFrameSrc = section.getAttribute('data-src');
                var iFrame = section.getElementsByTagName("iframe")[0];
				
                if (!isExpanded) {
                  // Load iframe contents if there are none
                  if (iFrame.getAttribute('src') == '') {
                    iFrame.setAttribute('src', iFrameSrc);
                  }
                  // Set the expanded state on the triggering element
                  item.setAttribute('aria-expanded', 'true');
                  // Hide the accordion sections, using aria-controls to specify the desired section
                  section.removeAttribute('hidden');
                  slideDown(section, 500); 
                }              
                else if (isExpanded) { 
                  item.setAttribute('aria-expanded', 'false');
                  // Hide the accordion sections, using aria-controls to specify the desired section
                  section.setAttribute('hidden', '');
                  slideUp(section, 500);                
                }              
            }
          }
          
          item_smfr = false;
          setTimeout (function () {
            	item_smfr = true;
          }, 500);
        });    
    
    });
    
    // Bind keyboard behaviors on the main accordion container
    accordion.addEventListener('keydown', function (event) {
      var target = event.target;
      var key = event.which.toString();
      
      var isExpanded = target.getAttribute('aria-expanded') == 'true';
      
      // 33 = Page Up, 34 = Page Down
      var ctrlModifier = (event.ctrlKey && key.match(/33|34/));      

      // Is this coming from an accordion header?
      if (target.classList.contains('Accordion-trigger')) {
        
        if (target.classList.contains('unit_title_row')) {
           var triggers = Array.prototype.slice.call(accordion.querySelectorAll('.unit_title_row'));
        } else if (target.classList.contains('lesson_title_row')) {
           var parent_unit = target.getAttribute('data-unit');
           var lesson_panel = document.getElementById(parent_unit);
           var triggers = Array.prototype.slice.call(lesson_panel.querySelectorAll('.lesson_title_button'));
        }
        
        
        
        // Up/ Down arrow and Control + Page Up/ Page Down keyboard operations
        // 38 = Up, 40 = Down
        if (key.match(/38|40/) || ctrlModifier) {
          var index = triggers.indexOf(target);
          var direction = (key.match(/34|40/)) ? 1 : -1;
          var length = triggers.length;
          var newIndex = (index + length + direction) % length;

          triggers[newIndex].focus();

          event.preventDefault();
        }
        else if (key.match(/35|36/)) {
          // 35 = End, 36 = Home keyboard operations
          switch (key) {
            // Go to first accordion
            case '36':
              triggers[0].focus();
              break;
              // Go to last accordion
            case '35':
              triggers[triggers.length - 1].focus();
              break;
          }
          event.preventDefault();

        }

      }      
    });
    
  });
  
  /* animate code from https://w3bits.com/javascript-slidetoggle/ */
  let slideUp = (target, duration=500) => {
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = duration + 'ms';
    target.style.boxSizing = 'border-box';
    target.style.height = target.offsetHeight + 'px';
    target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    window.setTimeout( () => {
      target.style.display = 'none';
      target.style.removeProperty('height');
      target.style.removeProperty('padding-top');
      target.style.removeProperty('padding-bottom');
      target.style.removeProperty('margin-top');
      target.style.removeProperty('margin-bottom');
      target.style.removeProperty('overflow');
      target.style.removeProperty('transition-duration');
      target.style.removeProperty('transition-property');
      //alert("!");
    }, duration);
  }

  let slideDown = (target, duration=500) => {
    target.style.removeProperty('display');
    let display = window.getComputedStyle(target).display;

    if (display === 'none')
      display = 'block';

    target.style.display = display;
    let height = target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.offsetHeight;
    target.style.boxSizing = 'border-box';
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + 'ms';
    target.style.height = height + 'px';
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    window.setTimeout( () => {
      target.style.removeProperty('height');
      target.style.removeProperty('overflow');
      target.style.removeProperty('transition-duration');
      target.style.removeProperty('transition-property');
    }, duration);
  }
  var slideToggle = (target, duration = 500) => {
    if (window.getComputedStyle(target).display === 'none') {
      return slideDown(target, duration);
    } else {
      return slideUp(target, duration);
    }
  }  